import { useNavigate } from 'react-router';
import { useTranslation } from '../i18n/I18nProvider';
import { HOME_BY_ROLE, useAuth } from '../auth/AuthProvider';
import { ErrorState } from '../ui';

export function NotFound() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="mx-auto w-full max-w-narrow px-5 py-16">
      <ErrorState
        title={t('error.notFound')}
        help={t('error.genericHelp')}
        retryLabel={t('common.back')}
        onRetry={() => void navigate(user ? HOME_BY_ROLE[user.role] : '/prijava')}
      />
    </div>
  );
}
